<div class="search-engine">
  <div
    class="search-engine__overlay"
    (click)="closeResults()"
    [ngClass]="{ 'search-engine__overlay--opened': isOpened }"
  ></div>
  <div class="search-engine__row">
    <div class="search-engine__input">
      <i class="fa fa-search"></i>
      <input
        type="text"
        [(ngModel)]="value"
        placeholder="{{ 'COMMON.SEARCH_ENGINE' | translate }}"
        (keyup.enter)="search()"
        (keyup.escape)="closeResults()"
        >
    </div>
    <div class="search-engine__btn" (click)="search()">{{ 'COMMON.SEARCH' | translate }}</div>
  </div>
  <div class="search-engine__results" [ngClass]="{ 'search-engine__results--opened': isOpened }">
    @if (!loading) {
      <div class="search-engine__list">
        @if (!isBusiness) {
          <div>
            @if (filteredStatements && filteredStatements.length) {
              <app-list-view-b2b
                [statements]="filteredStatements"
                (downloadInvoice)="downloadInvoice($event)"
                [hideRemoving]="true"
                >
              </app-list-view-b2b>
            }
            @if (!filteredStatements || !filteredStatements.length) {
              <div
                class="search-engine__empty"
                >
                {{ 'COMMON.SEARCH_EMPTY' | translate }}
              </div>
            }
          </div>
        }
        @if (isBusiness) {
          <div>
            @for (batch of filteredBatches; track batch; let i = $index) {
              <div class="search-engine__batch">
                <div>
                  <div class="search-engine__batch-text">
                    <span>{{ 'COMMON.BATCH_FILE' | translate }}</span>
                    <div class="search-engine__buttons">
                      @if (!hideEditButton(i)) {
                        <button
                          class="btn btn--info btn--small"
                          (click)="editBatch(i)"
                          [attr.data-cy]="'btnEditStatementBatch_'+i"
                          >
                          {{ 'COMMON.EDIT_BATCH' | translate }}
                        </button>
                      }
                    </div>
                  </div>
                  <div class="search-engine__batch-content">
                    <app-accordion
                      [title]="batch.code"
                      [titleFrame]="true"
                      [transparentBg]="true"
                      [noPadding]="true"
                      [canCollapse]="false"
                      >
                      <app-list-view-b2b
                        [statements]="batch.statements"
                        (deleteStatement)="deleteBatchStatement($event, i)"
                        [hideEditing]="true"
                        [hideInvoice]="true"
                      ></app-list-view-b2b>
                      @if (!batch?.statements?.length) {
                        <div
                          class="search-engine__batch-empty"
                          >
                          {{ 'COMMON.BATCH_EMPTY' | translate }}
                        </div>
                      }
                    </app-accordion>
                  </div>
                </div>
              </div>
            }
            @if (!filteredBatches|| !filteredBatches.length) {
              <div
                class="search-engine__empty"
                >
                {{ 'COMMON.SEARCH_EMPTY_BATCHES' | translate }}
              </div>
            }
          </div>
        }
      </div>
    }
    @if (loading) {
      <div class="search-engine__loading"></div>
    }
  </div>
</div>
